export default __webpack_public_path__ + "static/fiveam-03b744a624e831fceb44817021ec89fc.jpg";